module.exports = __webpack_public_path__ + "static/media/country_mu.a2f108fb.webp";